module.exports = __webpack_public_path__ + "img/Scout64_ua.e12deee4.webp";